import React, { useState, useEffect } from 'react';
import { Popover, Input } from 'antd';
import * as R from 'ramda';
import { useStoreActions } from 'easy-peasy';
import { Button, Loading } from 'Components/nui';
import { toast } from 'react-toastify';
import { useStoreState } from '~/store';
import { api } from '~/api';
import { FormattedMessage } from 'react-intl';

const PopoverContent = ({ product, orderType, formWrapper, setVisible }) => {
  const presets = useStoreState(state => state.auth.presets);
  const solution = useStoreState(state => state.auth.solution);
  const loadPresets = useStoreActions(R.path(['auth', 'loadPresets']));
  const updatePresets = useStoreActions(R.path(['auth', 'updatePresets']));

  useEffect(() => {
    if (presets === null) {
      loadPresets(solution.id);
    }
  }, [presets, solution, loadPresets]);

  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);

  const save = async () => {
    if (!name) return;

    setLoading(true);

    const data = {
      name,
      product: product.id,
      sell: orderType === 'offer',
      ...formWrapper.serialize(),
    };

    try {
      await api.postData('/presets', data);
      toast.success(`Preset "${name}" is saved`);
      setVisible(false);
      setName('');
      updatePresets(null);
    } catch (err) {
      const errors = R.path(
        ['response', 'data', 'errors', 0, 'description'],
        err
      );

      if (errors) {
        formWrapper.setErrors(errors);
        window.scrollTo(0, 0);
      } else {
        toast('An error occurred. Please try again later.', { type: 'error' });
      }
      if (err) {
        console.error(err);
      }
    }

    setLoading(false);
  };

  if (presets === null) return <Loading size="small" />;
  if (presets.length >= 20)
    return (
      <div className="preset-name">
        You have reached the limit of 20 presets.
        <br />
        To be able to save new presets, please remove unnecessary
        <br />
        from the list of the existing presets.
      </div>
    );

  return (
    <div className="preset-name">
      <Input
        placeholder="Name"
        style={{ width: 250 }}
        value={name}
        onChange={e => setName(e.target.value)}
        onPressEnter={save}
      />{' '}
      <Button
        htmlType="button"
        onClick={save}
        loading={loading}
        disabled={!name}
      >
        <FormattedMessage
          id="marketplace-filter-presets-field-save-button"
          description="Button for 'save preset' field in Marketplace filter"
          defaultMessage="Save"
        />
      </Button>
    </div>
  );
};

export function PresetButton({ product, orderType, formWrapper }) {
  const [visible, setVisible] = useState(false);

  return (
    <Popover
      content={
        <PopoverContent
          product={product}
          orderType={orderType}
          formWrapper={formWrapper}
          setVisible={setVisible}
        />
      }
      title={
        <FormattedMessage
          id="orderform-button-preset-modal-title"
          description="Title 'Preset name' for preset modal in new order form"
          defaultMessage="Preset name"
        />
      }
      trigger="click"
      visible={visible}
      onVisibleChange={v => setVisible(v)}
    >
      <Button htmlType="button" type="simple" className="ml-20 pl-0 pr-0">
        <FormattedMessage
          id="orderform-button-save-preset"
          description="button for 'Save as preset' in new order form"
          defaultMessage="Save as preset"
        />
      </Button>
    </Popover>
  );
}
